import { useTranslation } from "react-i18next";
import { Workflow } from "lucide-react";

export default function DoneInOneBadge({ quote }) {
  const { t } = useTranslation();
  const calc = quote?.calculation || {};
  if (!calc.swiss_done_in_one) return null;
  const machineName = (calc.breakdown || []).find((r) => r.machine_name)?.machine_name || "Fantina mobile";
  const setupMin = calc.totals?.total_setup_minutes;
  return (
    <div
      className="mb-6 border border-emerald-500/50 bg-gradient-to-r from-emerald-500/[0.08] to-emerald-500/[0.03] rounded-sm p-4"
      data-testid="done-in-one-badge"
    >
      <div className="flex items-start gap-3">
        <div className="w-8 h-8 rounded-sm bg-emerald-500/15 border border-emerald-500/40 flex items-center justify-center shrink-0">
          <Workflow size={16} className="text-emerald-300"/>
        </div>
        <div className="flex-1 min-w-0">
          <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-emerald-300 mb-1">
            // DONE_IN_ONE · SWISS-TYPE
          </div>
          <div className="font-display font-semibold text-slate-100 text-base mb-1" data-testid="done-in-one-title">
            {t("quoteDetail.doneInOneTitle")}
          </div>
          <p className="text-sm text-slate-300 leading-relaxed">
            {t("quoteDetail.doneInOneBody", { machine: machineName })}
          </p>
        </div>
        {Number.isFinite(setupMin) && (
          <div className="shrink-0 text-right">
            <div className="font-mono-data text-2xl text-emerald-300" data-testid="done-in-one-setup-min">
              {Math.round(setupMin)}<span className="text-sm text-emerald-400/70"> min</span>
            </div>
            <div className="text-[10px] font-mono uppercase tracking-wider text-slate-500">
              {t("quoteDetail.doneInOneSetupLabel")}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
